import React, { useEffect, useRef, useState } from "react";
import styles from "../../../assets/css/admin/layout.module.css";
import axios from "axios";
import SideBar from "../SideBar";
import { baseUrl } from "../../../baseUrl";
import { Link, useParams } from "react-router-dom";
import {useAuth} from "../../../AuthContext"
import { useSidebar } from "../../../context/SidebarContext";
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close'
import api from "../../../api";
import { toast } from "react-toastify";

const EditCourse = () => {
  const { logout, user } = useAuth();
  const { isSidebarOpen, toggleSidebar } = useSidebar();
    const [message,setMessage]=useState(false)
    const [message2,setMessage2]=useState(false)
    const [className,setClassName]=useState('')
    const [courseID,setCourseID]=useState()
    const [title,setTitle]=useState("")
    const [active,setActive]=useState(false)
    const [duration,setDuration]=useState("")
    const [description,setDescription]=useState("")
    const [originalPrice,setOriginalPrice]=useState('')
    const [price,setPrice]=useState("")
    const [tests,setTests]=useState("")
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const today = new Date().toISOString().split("T")[0];
    const params=useParams()
    const fileRef=useRef()
    const imgFileRef=useRef()
    const [file,setFile]=useState(null)
    const [imgFile,setImgFile]=useState(null)
    const [prevFile,setPrevFile]=useState(null)
    const [prevImgFile,setPrevImgFile]=useState(null)


    const data={className,courseID,title,duration,description,originalPrice,price,tests,startDate,endDate,active}
  useEffect(() => {
    const timer = setTimeout(() => {
      setMessage(false);
    }, 4000);
    return () => clearTimeout(timer);
  }, [message]);
  useEffect(() => {
    const timer = setTimeout(() => {
      setMessage2(false);
    }, 4000);
    return () => clearTimeout(timer);
  }, [message2]);
    const getCourse=()=>{
        axios.get(`${baseUrl}/course/get?id=${params.id}`)
        .then(res=>{
            setClassName(res.data.className)
            setCourseID(res.data.courseID)
            setTitle(res.data.title)
            setDuration(res.data.duration)
            setDescription(res.data.description)
            setOriginalPrice(res.data.originalPrice)
            setPrice(res.data.price)
            setTests(res.data.tests)
            setStartDate(res.data.startDate)
            setEndDate(res.data.endDate)
            setPrevFile(res.data.syllabus)
            setPrevImgFile(res.data.image)
            setActive(res.data.active)
        })
    }

    useEffect(()=>{
        getCourse()
    },[])
  const handleSubmit = (e) => {
    api
      .post(`${baseUrl}/course/update?id=${params.id}`, data)
      .then((res) => {
        if (res.data === "success") {
          setMessage("Course updated successfully");
        }
        if (res.data === "failed") {
          setMessage("Something went wrong");
        }
      })
      .catch((err) => {
        toast.error(err?.response?.data.message || "Something went wrong")
        console.log(err)});
  };


  const handleFile=(e)=>{
    const validFileTypes = ['application/pdf'];
    const maxSizeInBytes = 2 * 1024 * 1024;
    if (validFileTypes.includes(e.target.files[0].type) &&
      e.target.files[0].size <= maxSizeInBytes) 
    {
      setFile(e.target.files)
    }
    else{
      setMessage2('Invalid file. Only PDF files under 2MB are allowed.')
      setFile(null);
      fileRef.current.value=""
    }
  }
  const handleImgFile=(e)=>{
    const validFileTypes = ['image/jpeg','image/jpg','image/png'];
    const maxSizeInBytes = 2 * 1024 * 1024;
    if (validFileTypes.includes(e.target.files[0].type) &&
      e.target.files[0].size <= maxSizeInBytes) 
    {
      setImgFile(e.target.files)
    }
    else{
      setMessage('Invalid file. Only Image files (jpeg,jpg,png) under 2MB are allowed.')
      setImgFile(null);
      imgFileRef.current.value=""
    }

  }
  const uploadFile=()=>{
    if(!file){
      setMessage2('Please select syllabus file')
    }

    else{
      const formData = new FormData();
      formData.append('file', file[0]);
      api.post(`${baseUrl}/course/upload?id=${courseID}&path=${prevFile}`,formData)
      .then(res=>{
        setMessage2("Syllabus pdf updated")
        getCourse()
      })
      .catch(err=>{
        toast.error(err?.response?.data.message || "Something went wrong")
        console.log(err)})
    }
  }
  const uploadImgFile=()=>{
    if(!imgFile){
      setMessage2('Please choose image')
    }

    else{
      const formData = new FormData();
      formData.append('file', imgFile[0]);
      api.post(`${baseUrl}/course/upload?id=${courseID}&imgPath=${prevImgFile}`,formData)
      .then(res=>{
        setMessage2("Image updated")
        getCourse()
      })
      .catch(err=>{
        toast.error(err?.response?.data.message || "Something went wrong")
        console.log(err)})
    }
  }
  return (
    <div className={`${styles.layout} ${isSidebarOpen ? '' : `${styles.sidebarClosed}`}`}>
      <aside className={`${styles.sidebar} ${isSidebarOpen ? `${styles.open}` : `${styles.closed}`}`}>
        <SideBar />
      </aside>

      <main className={styles.mainContent}>
      <div style={{ height: '30px' }} className="position-relative">{isSidebarOpen ? <CloseIcon className={`position-absolute end-0 ${styles.ham}`} onClick={toggleSidebar} /> : <MenuIcon className={`position-absolute end-0 ${styles.ham}`} onClick={toggleSidebar} />}</div>
        <nav aria-label="breadcrumb" >
          <ol className="breadcrumb">
            <div className="d-flex flex-grow-1">
              <li className="breadcrumb-item">
                <Link to='/admin/dashboard' className="text-decoration-none">Dashboard</Link>
              </li>
              <li className="breadcrumb-item">
                <Link to='/admin/courses' className="text-decoration-none">All Courses</Link>
              </li>
              <li className="breadcrumb-item active">
                Edit
              </li>
            </div>
            <li className="nav-item dropdown">
              <span
                className="nav-link dropdown-toggle"
                data-bs-toggle="dropdown"
                href=""
                role="button"
                aria-expanded="false"
              >
                Welcome, {user.name}
                <i className="ml-2 fa fa-angle-down"></i>
              </span>
              <ul className="dropdown-menu" style={{ minWidth: '150px' }}>
                <li>
                  <span className="dropdown-item" onClick={logout}>
                    Logout
                  </span>
                </li>
              </ul>
            </li>
          </ol>
        </nav>
        <div className={`container ${styles.container}`}>
          <div className="bg-white p-4">
            <h4>Edit Course</h4>
            <div className="row mb-3">
              <div className="col-lg-6">
                <label htmlFor="title" className="form-label">
                  Course Title
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="title"
                  placeholder="Enter Course Title"
                  onChange={(e) => setTitle(e.target.value)}
                  value={title}
                />
              </div>
              <div className="col-lg-6">
                <label htmlFor="duration" className="form-label">
                  Duration
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="duration"
                  placeholder="Enter course duration"
                  onChange={(e) => setDuration(e.target.value)}
                  value={duration}
                />
              </div>
            </div>
            <div className="row mb-3">
              <div className="col-lg-6">
                <label htmlFor="courseID" className="form-label">
                  Course ID
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="courseID"
                  placeholder="Enter course ID"
                  onChange={(e) => setCourseID(e.target.value)}
                  value={courseID}
                />
              </div>
              <div className="col-lg-6">
                <label htmlFor="class" className="form-label">
                  Select Class
                </label>
                <select
                  onChange={(e) => setClassName(e.target.value)}
                  className="form-select"
                  id="class"
                  aria-label="Default select example"
                  value={className}
                >
                  <option value=''>Select class</option>
                    <option>
                      Class XI
                    </option>
                    <option>
                      Class XII
                    </option>
                    <option>
                      Class XII Passed
                    </option>
                </select>
              </div>
            </div>
            <div className="row mb-3">
              <div className="col-12">
                <label htmlFor="description" className="form-label">
                  Descripton
                </label>
                <textarea
                  onChange={(e) => setDescription(e.target.value)}
                  className="form-control"
                  value={description}
                ></textarea>
              </div>
            </div>

            <div className="row mb-3">
            <div className="col-lg-4">
                <label htmlFor="originalPrice" className="form-label">
                  Original Price (₹)
                </label>
                <input
                  type="number"
                  className="form-control"
                  id="originalPrice"
                  placeholder="Enter original price"
                  onChange={(e) => setOriginalPrice(e.target.value)}
                  value={originalPrice}
                />
              </div>
              <div className="col-lg-4">
                <label htmlFor="price" className="form-label">
                  Price (₹)
                </label>
                <input
                  type="number"
                  className="form-control"
                  id="duration"
                  placeholder="Enter Price"
                  onChange={(e) => setPrice(e.target.value)}
                  value={price}
                />
              </div>
              <div className="col-lg-4">
                <label htmlFor="tests" className="form-label">
                  Number of tests
                </label>
                <input
                  value={tests}
                  type="number"
                  className="form-control"
                  id="tests"
                  placeholder="Enter number of tests"
                  onChange={(e) => setTests(e.target.value)}
                />
              </div>
            </div>
            <div className="row mb-3">
              <div className="col-lg-6">
                <label htmlFor="startDate" className="form-label">
                  Start Date
                </label>
                <input
                  type="date"
                  className="form-control"
                  id="startDate"
                  placeholder=""
                  onChange={(e) => setStartDate(e.target.value)}
                  value={startDate}
                  min={today}
                />
              </div>
              <div className="col-lg-6">
                <label htmlFor="endDate" className="form-label">
                  End Date
                </label>
                <input
                  type="date"
                  className="form-control"
                  id="endDate"
                  placeholder=""
                  onChange={(e) => setEndDate(e.target.value)}
                  value={endDate}
                  min={today}
                />
              </div>
            </div>
            <div className="row mt-3">
              <div className="col-lg-6">
                <label htmlFor="status" className="form-label">
                  Status :                   {
                    active ?
                      <label htmlFor="active" className="form-label">
                        Active
                      </label> :
                      <label htmlFor="inactive" className="form-label">
                        Inactive
                      </label>
                  }
                  <input checked={active} onChange={() => setActive(!active)} className="ml-2" type="checkbox" />
                </label>
              </div>
            </div>
            {message && (
              <div
                className="alert alert-warning alert-dismissible fade show mt-3"
                role="alert"
              >
                {message}
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="alert"
                  aria-label="Close"
                  onClick={() => setMessage(false)}
                ></button>
              </div>
            )}
            <button onClick={handleSubmit} className="btn btn-primary btn-sm mt-4">
              Update Details
            </button>
            <div className="row mt-3">
              <div className="col-lg-6">
                <label htmlFor="file" className="form-label">
                  Syllabus
                </label>
                <input
                id="file"
                  ref={fileRef}
                  onChange={handleFile}
                  type="file"
                  className="form-control"
                />
                <button onClick={uploadFile} className="btn btn-primary btn-sm mt-4">
                  Update Syllabus
                </button>
              </div>
              <div className="col-lg-6">
                <label htmlFor="imgFile" className="form-label">
                  Image
                </label>
                <input
                id="imgFile"
                  ref={imgFileRef}
                  onChange={handleImgFile}
                  type="file"
                  className="form-control"
                />
                <button onClick={uploadImgFile} className="btn btn-primary btn-sm mt-4">
                  Update image
                </button>
              </div>
            </div>
            {message2 && (
              <div
                className="alert alert-warning alert-dismissible fade show mt-3"
                role="alert"
              >
                {message2}
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="alert"
                  aria-label="Close"
                  onClick={() => setMessage2(false)}
                ></button>
              </div>
            )}
          </div>
        </div>
      </main>
    </div>
  );
};

export default EditCourse;
